module.exports = {"421224100":"通羊镇","421224101":"南林桥镇","421224102":"黄沙铺镇","421224103":"厦铺镇","421224104":"九宫山镇","421224105":"闯王镇","421224106":"洪港镇","421224107":"大畈镇","421224200":"大路乡","421224201":"杨芳林乡","421224202":"燕厦乡","421224203":"慈口乡","421224450":"九宫山自然保护管理局","421224570":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421224.json
// module id = 1635
// module chunks = 0